'use client'

import { useAtom } from 'jotai'

import LogoIcon from '@/assets/images/symbol-gata.svg?react'
import { Trans } from '@/components'
import { atomLoginStatus } from '@/stores/login'

import WaitingSigning from './components/waiting-signing'
import WalletsDialog from './components/wallets-dialog'

export function LoginPage() {
  const [loginStatus] = useAtom(atomLoginStatus)
  return (
    <div className="flex flex-col items-center gap-y-8 md:px-6">
      <div className="card bg-panel-white w-[480px] md:w-full flex flex-col items-center gap-4">
        <LogoIcon className="w-10 h-10" />
        <div className="w-full py-2 flex flex-col items-center gap-4">
          {loginStatus === 'initial' ? (
            <view className="flex flex-row items-center justify-start text-left ">
              <view className="font-semibold text-2xl leading-8 tracking-normal text-left align-middle text-Text-Primary">
                Welcome to Gata
              </view>
            </view>
          ) : null}

          <WalletsDialog />
          <WaitingSigning />
        </div>
      </div>
      <div className="max-w-[480px] text-center t-sm text-secondary">
        <Trans i18nKey="login.agreement">
          You acknowledge that you read, and agree to our
          <a className="text-primary" href="https://gata.net/terms-of-use">
            Terms of Service
          </a>
          and
          <a className="text-primary" href="https://gata.net/privacy-policy">
            Privacy Policy
          </a>
        </Trans>
      </div>
    </div>
  )
}
